<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .gbox-wrap.news.aaa
        contactUs(:fixed="true")
        .news-list-wrap
          template(v-if="newsList.length > 0")
            .news-listbox(v-for="news in newsList")
              .iimg
                img(:src="imgUrl+news.en_image_url")
              .ccon
                div(v-html="news.en_title")
                div(v-html="news.en_preview_body")
                router-link.btn-submit(:to="'/news/'+news.slug") Read more >>
          //- .news-listbox 
          //-   .iimg
          //-     img(src="assets/img/news/gettingstart.png")
          //-   .ccon
          //-     h3 What is EpicWin? The 2024 Guide
          //-     p In Malaysia, 60% of smartphone users play slot games every day. This shows how big the love for slots is. EpicWin is a unique platform that mixes the fun of online casino games with the joy of winning.
          //-     router-link.btn-submit(to="getting-started") Read more >>
          //- .news-listbox 
          //-   .iimg
          //-     img(src="assets/img/news/new.jpg")
          //-   .ccon
          //-     h3 Exploring Online Slot Malaysia as A New Player
          //-     p Welcome to the bright and exciting world of slot Malaysia. It's a place filled with vibrant lights and sounds, offering endless fun and the chance to win. As you step into the online entertainment world, discover a variety of online slots waiting for every new player. If you're just beginning, the world of online slot Malaysia may seem amazing but a bit daunting. But don't worry, we're here to help you enjoy this journey, making your experience fantastic and engaging.
          //-     router-link.btn-submit(to="exploring-online-slot-malaysia-as-a-new-player") Read more >>
          //- //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/free-kredit-10.jpg")
          //-   .ccon
          //-     h3 Malaysians Flock to Claim Free Kredit RM10 and E-Wallet Rewards at EpicWin
          //-     p In today's digital age, online casinos have become increasingly popular, providing Malaysians with a convenient and exciting way to enjoy their favorite casino games. With a wide range of options available, it can be overwhelming to choose the right online casino. However, if you're looking for a trusted online casino Malaysia, look no further than our site – EpicWin Malaysia.
          //-     router-link.btn-submit(to="rm10-free-credit") Read more >>
          //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/jili-new.jpg")
          //-   .ccon
          //-     h3 JILI Provider Emerges as the New Sensation in Online Slot Games at EpicWin
          //-     p In the world of online slot games, the JILI provider has recently emerged as a new sensation, captivating players at EpicWin. With its innovative approach and top-notch gaming experience, it has quickly gained popularity among online casino enthusiasts.
          //-     router-link.btn-submit(to="jili-slot-epicwin") Read more >>
          //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/epicwin888.jpg")
          //-   .ccon
          //-     h3 Malaysia's Online Casino Craze: EpicWin888 Introduces Innovative Promotions
          //-     p In recent years, Malaysia has witnessed a tremendous surge in the popularity of online casinos. The convenience and excitement of playing casino games from the comfort of one's own home have enticed a growing number of Malaysians to join the online gambling community. One platform that has stood out in this increasingly competitive market is EpicWin888.
          //-     router-link.btn-submit(to="online-casino-epicwin888") Read more >>
          //- //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/casino.png")
          //-   .ccon
          //-     h3 Online Casino Malaysia | TNG e-Wallet Casino - Epicwin
          //-     p Online casinos in Malaysia have quickly become the go-to choice for casino fans looking for an exciting gaming experience. As one of the most visited countries for gambling, with hundreds of different types of games, there is no wonder why so many people are choosing to gamble online in Malaysia. 
          //-     router-link.btn-submit(to="online-casino-malaysia") Read more >>
          //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/ewallet.png")
          //-   .ccon
          //-     h3 E-Wallet Casino | E-wallet Casino Free Credit - Epicwin
          //-     p If you’re an online casino enthusiast, you may have heard of e-wallet casinos. These are becoming increasingly popular in Malaysia due to their convenience, speed, and reliability. In this blog post, we’ll explore what e-wallet casinos are, why they are so popular, and how they benefit both players and operators. 
          //-     router-link.btn-submit(to="e-wallet-casino") Read more >>
          //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/freecreditrm10.png")
          //-   .ccon
          //-     h3 Free Kredit RM10 | Claim Free Credit RM10 - Epicwin
          //-     p Have you ever heard of Free Kredit RM10? You may have seen it advertised on TV or in social media apps and wondered what it is. Well, you’re not alone. Many Malaysians have heard of this mysterious offer but don’t know what it is or how to take advantage of it. 
          //-     router-link.btn-submit(to="free-kredit-rm10") Read more >>
          //- .news-listbox
          //-   .iimg
          //-     img(src="assets/img/news/freecreditslot.png")
          //-   .ccon
          //-     h3 Free Credit Slot | Free Credit e-wallet Slot - Epicwin
          //-     p Are you a fan of online casino games? Have you wanted to try a free credit slot but don’t know how? If so, then read on! Find out what is a free credit slot, why it is so popular, how you can use it to your advantage, and more! Plus, you’ll get to know which slot games are worth the try with a free credit slot!
          //-     router-link.btn-submit(to="free-credit-slot") Read more >>
          //- .news-listbox
            .iimg
              img(src="assets/img/news/onlineslotmalaysia.png")
            .ccon
              h3 Mobile Slot Malaysia | Online Slot Malaysia - Epicwin
              p EpicWin is a trusted online slot Malaysia site that provides exciting slot games with stunning graphics and interactive gameplay. Players can access various slots, including classic, popular, and newly released games. With regular bonuses and promotions, EpicWin keeps things fresh and exciting!
              router-link.btn-submit(to="online-slot-malaysia") Read more >>
</template>
<script>
import config from "@/config";
import contactUs from '@/views/default/_contactUs.vue'
export default {
  // metaInfo:{
  //   title: 'Casino News | EpicWin Latest Update',
  //   meta:[
  //     {vmid: "description",name: 'description', content: "Stay updated with the latest news from EpicWin. Get the newest updates on games, promotions happening at our online casino."}
  //   ],
  // },
  components:{
    contactUs
  },
  data(){
    return{
      feedback:{
        success: true,
        status:""
      },
      loading: false,
      newsList:[],
      imgUrl: config.imageUrl,
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  created(){
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/news');
    this.getNewsList()
  },
  mounted(){
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    getNewsList(){
      var lang = "en"
      this.$store
        .dispatch("user/getNewsList",{lang})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.newsList = response.data
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    }
  }
}
</script>